module.exports = __webpack_public_path__ + "img/4.2784b063.webp";